module.exports = __webpack_public_path__ + "img/root010.470700a8.png";